// import React, { Fragment, useState } from "react";
// import Select, { createFilter, components } from "react-select";

import React, { Fragment, useState, useMemo } from "react";
import Select, { components, createFilter } from "react-select";

const InputOptionCheckbox = ({
  getStyles,
  Icon,
  isDisabled,
  isFocused,
  isSelected,
  children,
  innerProps,
  ...rest
}) => {
  const [isActive, setIsActive] = useState(false);
  const onMouseDown = () => setIsActive(true);
  const onMouseUp = () => setIsActive(false);
  const onMouseLeave = () => setIsActive(false);

  // styles
  let bg = "transparent";
  if (isFocused) bg = "#eee";
  if (isActive) bg = "#B2D4FF";

  const style = {
    alignItems: "center",
    backgroundColor: bg,
    color: "inherit",
    display: "flex",
    gap: "10px",
    overflow: "hidden !important",
  };

  // prop assignment
  const props = {
    ...innerProps,
    onMouseDown,
    onMouseUp,
    onMouseLeave,
    style,
  };
  // const maxToShow = 1;
  // const overflow = getValue()
  //   .slice(maxToShow)
  //   .map((x) => x.label);
  return (
    <components.Option
      {...rest}
      isDisabled={isDisabled}
      isFocused={isFocused}
      isSelected={isSelected}
      getStyles={getStyles}
      innerProps={props}
    >
      <input
        type="checkbox"
        className="form-check-input"
        checked={isSelected}
        readOnly
      />
      {children}
    </components.Option>
  );
};
const MoreSelectedBadge = ({ items }) => {
  const style = {
    marginLeft: "-7px",
    background: "#fff",
    color: "#000",
    // fontWeight: "bold",
    borderRadius: "3px",
    fontFamily: "Open Sans",
    fontSize: "10px",
    padding: "3px 4px",
    order: 99,
    outline: "1px solid #289ef9",
  };

  const title = items.join(", ");
  const length = items.length;
  const label = `+${length} من العناصر المحدده`;

  return (
    <div style={style} title={title}>
      {label}
    </div>
  );
};
const MultiValue = ({ index, getValue, ...props }) => {
  const maxToShow = 1;
  const overflow = getValue()
    .slice(maxToShow)
    .map((x) => x.label);

  return index < maxToShow ? (
    <components.MultiValue {...props} />
  ) : index === maxToShow ? (
    <MoreSelectedBadge items={overflow} />
  ) : null;
};

function SearchSelectElement(props) {
  // ---------- styles ----------
  let disabledStyle = {};
  if (props.disabled) disabledStyle = { backgroundColor: "#e9ecef" };

  const customStyles = {
    control: (base) => ({
      ...base,
      height: 50,
      minHeight: 50,
      borderRadius: "10px",
      border: 0,
      boxShadow: "0px 3px 6px #005da838",
      ...disabledStyle,
    }),
    singleValue: (provided) => ({ ...provided, color: "#212529" }),
    menu: (provided) => ({ ...provided, zIndex: 9999 }),
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    multiValueRemove: (style, state) => {
      return {
        ...style,
        ...(props.isOptionDisabled
          ? {
              visibility: "hidden",
              width: "4px",
            }
          : {}),
      };
    },
  };

  // ---------- normalize stored value -> react-select value ----------
  // For multi-select, react-select expects: value = [{value,label}, ...]
  // But you might store: [{id}], [ids], or already option objects.
  const selectValue = useMemo(() => {
    if (!props.options) return props.isMulti ? [] : null;

    // MULTI
    if (props.isMulti) {
      const raw = props.value;

      // already array of react-select option objects?
      if (Array.isArray(raw) && raw.length > 0 && raw[0]?.value !== undefined) {
        return raw;
      }

      // array of {id: ...}
      const idsFromObjects =
        Array.isArray(raw) && raw.length > 0 && raw[0]?.id !== undefined
          ? raw.map((x) => String(x.id)) // normalize to string
          : null;

      // array of ids directly
      const idsFromArray =
        Array.isArray(raw) &&
        (raw.length === 0 ||
          typeof raw[0] === "number" ||
          typeof raw[0] === "string")
          ? raw.map((x) => String(x)) // normalize to string
          : null;

      const ids = idsFromObjects ?? idsFromArray ?? [];

      return props.options.filter((opt) => ids.includes(String(opt.value)));
    }

    // SINGLE
    if (props.value === null || props.value === undefined || props.value === "")
      return null;

    // if type is string, compare directly
    if (props.type === "string") {
      return (
        props.options.find(
          (opt) => String(opt.value) === String(props.value),
        ) ?? null
      );
    }

    // fallback: try numeric comparison, but also allow string equality (UUIDs)
    return (
      props.options.find(
        (opt) =>
          String(opt.value) === String(props.value) ||
          (Number.isFinite(parseInt(opt.value, 10)) &&
            parseInt(opt.value, 10) === parseInt(props.value, 10)),
      ) ?? null
    );
  }, [props.value, props.options, props.isMulti, props.type]);

  // ---------- onChange ----------
function handleChange(selectedOption) {
  if (props.isMulti) {
    const values = Array.isArray(selectedOption)
      ? selectedOption.map((x) => String(x.value)) // normalize to string
      : [];

    props.onChange(
      props.parentCompenent,
      props.compenent,
      props.name,
      values,
      props.index,
      props.buildingIndex,
      props.floorIndex,
    );
    return;
  }

  if (selectedOption) {
    const val = String(selectedOption.value); // normalize
    if (props.payment && parseInt(props.payment, 10) === 1) {
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        val,
        selectedOption.label,
        props.buildingIndex,
      );
    } else if (props.northCoast === true) {
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        val,
        selectedOption.label,
        props.index,
        selectedOption.region_id,
      );
    } else {
      props.onChange(
        props.parentCompenent,
        props.compenent,
        props.name,
        val,
        props.index,
        props.buildingIndex,
        props.floorIndex,
      );
    }
  } else {
    props.onChange(
      props.parentCompenent,
      props.compenent,
      props.name,
      null,
      null,
      props.index,
      props.buildingIndex,
      props.floorIndex,
    );
  }
}

  const labelOnlyFilter = createFilter({
    stringify: (option) => String(option.label ?? ""),
    ignoreCase: true,
    ignoreAccents: true,
    trim: true,
    matchFrom: "any",
  });

  return (
    <Fragment>
      <div className={props.mb4} id={`${props.selectID}_container`}>
        <label htmlFor={props.labelHtmlFor} className={props.labelClassName}>
          {props.labelText}
        </label>

        <Select
          key={`select__${props.selectID}`}
          value={selectValue}
          id={props.selectID}
          inputId={props.inputId}
          isDisabled={props.disabled}
          onChange={handleChange}
          options={props.options}
          isMulti={props.isMulti}
          closeMenuOnSelect={props.isMulti && false}
          hideSelectedOptions={props.isMulti && false}
          isClearable={props.isClearable}
          placeholder={props.default}
          styles={customStyles}
          menuPortalTarget={
            typeof document !== "undefined" ? document.body : null
          }
          menuPosition="fixed"
          noOptionsMessage={({ inputValue }) =>
            inputValue ? "لا يوجد اختيارات" : null
          }
          filterOption={props.filterOption || labelOnlyFilter}
          isRtl={true}
          isOptionDisabled={props.isOptionDisabled}
          components={
            props.isMulti && props.cursorIfEmpty
              ? { ...props.components, Option: InputOptionCheckbox, MultiValue }
              : props.isMulti
                ? { Option: InputOptionCheckbox, MultiValue }
                : props.components
          }
        />

        {props.pText && <p className={props.pClassName}>{props.pText}</p>}
      </div>
    </Fragment>
  );
}

export default SearchSelectElement;
